import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit {
  isLoading = false;
  showForm = false;
  countProviders = 0;
  providersThreshold = environment.providersThreshold;
  isBrowserOutdated = false;
  urlSignUp = `${environment.appUrl}/auth/signup`;
  wipperozLogo =
    'https://cdn.sanity.io/images/jizm7zxy/production/eca04a468bb51fd5165d6e25cd62302a3aa3cf7e-300x117.png?fm=webp&q=60&w=200';
  bannerBGImage = `https://cdn.sanity.io/images/jizm7zxy/production/a46afdf36a4de2b06362fe19b45b0b2e496d3deb-1600x972.png?fm=webp&q=75`;

  constructor() {}

  ngOnInit(): void {}
}
